import * as React from "react";
import { Table } from "reactstrap";

function ExampleCsvPopover() {
  return (
    <div className="example-csv-help">
      <Table hover bordered>
        <thead>
          <tr>
            <th>Cow number/name</th>
            <th>Cow Sire</th>
            <th>Maternal Grandsire</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>abc123</td>
            <td>112080</td>
            <td>108187</td>
          </tr>
        </tbody>
      </Table>
      <ul>
        <li>Use LIC bull codes only</li>
        <li>Non-LIC bull codes will be treated as unknown</li>
        <li>Empty cells will be treated as unknown</li>
        <li>Cow number/name cell allows alphanumeric text</li>
        <li>The column should be separated by comma</li>
        <li>Columns must be ordered and named as follows</li>
        <li className="columns-order">
          <ol>
            <li>Cow number/name</li>
            <li>Cow Sire</li>
            <li>Maternal Grandsire</li>
          </ol>
        </li>
      </ul>
    </div>
  );
}

export default ExampleCsvPopover;



// WEBPACK FOOTER //
// ./src/scripts/components/ExampleCsvPopover.tsx